var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { FelaComponent } from '@filou/core';
import underliner from '../../underliner';
var rule = function (_a) {
    var theme = _a.theme, active = _a.active;
    return (__assign({ marginLeft: 20, ifMediumDown: {
            marginLeft: 10
        }, color: theme.dark, textDecoration: 'none' }, underliner(theme, 16, active)));
};
var Link = function (_a) {
    var children = _a.children, to = _a.to, active = _a.active;
    return (React.createElement(FelaComponent, { rule: rule, active: active, render: function (_a) {
            var className = _a.className;
            return (React.createElement("a", { onClick: function (e) {
                    var element = document.getElementById(to.substr(1));
                    if (element) {
                        e.preventDefault();
                        element.scrollIntoView({
                            behavior: 'smooth'
                        });
                    }
                }, href: to, className: className }, children));
        } }));
};
export default Link;
//# sourceMappingURL=index.js.map